<template>
    <div class="form-container">
        <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary);">Create Scenario</h2>
        <div class="form-section">
            <div class="form-group">
                <label>Action Name</label>
                <input type="text" placeholder="create scenario" v-model="actionName" />
            </div>
            <div class="form-group">
                <label>Scenario Name</label>
                <input type="text" placeholder="e.g. Q4 Forecast" v-model="scenarioName" />
            </div>
            <div class="form-group">
                <label>Scenario Description</label>
                <input type="text" placeholder="e.g. Fourth quarter projection" v-model="scenarioDescription" />
            </div>
            <div class="form-group">
                <label>Technology</label>
                <select v-model="technology">
                    <option value="">Select Technology</option>
                    <option v-for="tech in TECHNOLOGIES" :key="tech" :value="tech">
                        {{ tech }}
                    </option>
                </select>
            </div>
            <button class="button button-full" @click="addWorkflowItem">Add Workflow Item</button>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { addWorkflowItem as addWorkflowItemUtil, createScenarioWorkflowItem, TECHNOLOGIES } from '../utils/workflowUtils';

const actionName = ref('');
const scenarioName = ref('');
const scenarioDescription = ref('');
const technology = ref('');

const addWorkflowItem = async () => {
    // Create the workflow item data
    const { keys, values } = createScenarioWorkflowItem(
        actionName.value,
        scenarioName.value,
        scenarioDescription.value,
        technology.value
    );

    // Add to workflow sheet using utility
    await addWorkflowItemUtil(keys, values);
};
</script>
